/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBatteryDto } from './GetBatteryDto';
import {
    GetBatteryDtoFromJSON,
    GetBatteryDtoFromJSONTyped,
    GetBatteryDtoToJSON,
} from './GetBatteryDto';

/**
 * 
 * @export
 * @interface GetCompanyBatteryDto
 */
export interface GetCompanyBatteryDto {
    /**
     * 
     * @type {string}
     * @memberof GetCompanyBatteryDto
     */
    id: string;
    /**
     * 
     * @type {GetBatteryDto}
     * @memberof GetCompanyBatteryDto
     */
    battery: GetBatteryDto;
}

/**
 * Check if a given object implements the GetCompanyBatteryDto interface.
 */
export function instanceOfGetCompanyBatteryDto(value: object): value is GetCompanyBatteryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('battery' in value) || value['battery'] === undefined) return false;
    return true;
}

export function GetCompanyBatteryDtoFromJSON(json: any): GetCompanyBatteryDto {
    return GetCompanyBatteryDtoFromJSONTyped(json, false);
}

export function GetCompanyBatteryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyBatteryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'battery': GetBatteryDtoFromJSON(json['battery']),
    };
}

export function GetCompanyBatteryDtoToJSON(value?: GetCompanyBatteryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'battery': GetBatteryDtoToJSON(value['battery']),
    };
}

